import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from './services/toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private translate: TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        let errorMessage: string = '';

        if (
          error?.status == 400 ||
          error?.status == 404 ||
          error?.status == 500
        ) {
          if (error?.error?.Errors?.length) {
            let errorMessageArr = error?.error?.Errors?.map(
              (e: { Errors: any }) => e.Errors
            );
            for (let i = 0; i < errorMessageArr.length; i++) {
              errorMessage += errorMessageArr[i];
            }
            errorMessage = errorMessage.replace(',', '');
          } else {
            errorMessage = error?.error?.detail;
          }
        } else if (error?.status == 401) {
          errorMessage = this.translate.instant('error.unauthorized');
        } else if (error?.status == 403) {
          errorMessage = this.translate.instant('error.forbidden');
        } else if (error?.status == 405) {
          errorMessage = this.translate.instant('error.methodNotAllowed');
        } else {
          errorMessage = this.translate.instant('error.errorOccured');
        }
        this.toastService.showToast(errorMessage, 'error');
        return throwError(() => error);
      })
    );
  }
}
